import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import CookiePrivacyPolicyPopup from "@insite/content-library/Components/CookiePrivacyPolicyPopup";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import UCSColors from "@ucs/Utils/UCSColors";
import * as React from "react";
import { css } from "styled-components";

export interface FooterStyles {
    page?: MobiusPageProps;
    css?: InjectableCss;
}

export const footerStyles: FooterStyles = {
    page: {
        fullWidth: [true, true, true, true, true],
    },
    css: {
        css: css`
            background-color: ${UCSColors.gray01};
            display: flex;
            justify-items: center;
            justify-content: center;
        `,
    },
};
const styles = footerStyles;

const Footer = ({ id }: PageProps) => (
    <Page as="footer" id="footer" {...styles.page}>
        <StyledWrapper {...styles.css}>
            <Zone contentId={id} zoneName="Content" />
	    <CookiePrivacyPolicyPopup />
        </StyledWrapper>
    </Page>
);

const pageModule: PageModule = {
    component: Footer,
    definition: {
        hasEditableTitle: false,
        hasEditableUrlSegment: false,
        pageType: "System",
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "Footer" instead of this constant.
 */
export const FooterContext = "Footer";